// Fix custom element conflicts BEFORE any other imports
(function() {
  // Handle iframe context and custom element conflicts
  const originalDefine = window.customElements.define;
  const definedElements = new Set();
  
  // More aggressive custom element override
  window.customElements.define = function(name, constructor, options) {
    // Check multiple ways if element already exists
    let alreadyDefined = false;
    try {
      alreadyDefined = definedElements.has(name) || 
                     window.customElements.get(name) !== undefined ||
                     document.createElement(name).constructor !== HTMLElement;
    } catch (e) {
      // If we can't check, assume it might be defined
    }
    
    if (alreadyDefined) {
      console.log(`Custom element '${name}' already defined, skipping registration`);
      return;
    }
    
    try {
      definedElements.add(name);
      originalDefine.call(window.customElements, name, constructor, options);
    } catch (error) {
      console.warn(`Failed to define custom element '${name}':`, error.message);
      if (error.message.includes('already been defined')) {
        // Silently ignore duplicate registration errors
        return;
      }
      // Don't throw for other errors either, just log
    }
  };
  
  // Suppress error throwing for custom element conflicts
  window.addEventListener('error', function(event) {
    if (event.error && event.error.message && 
        event.error.message.includes('already been defined')) {
      console.warn('Suppressed custom element error:', event.error.message);
      event.preventDefault();
      return false;
    }
  });
  
  // Also handle unhandled promise rejections
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('already been defined')) {
      console.warn('Suppressed custom element promise rejection:', event.reason.message);
      event.preventDefault();
      return false;
    }
  });
  
  // Override console.error to suppress specific errors
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const message = args[0];
    if (typeof message === 'string' && 
        (message.includes('already been defined') || 
         message.includes('mce-autosize-textarea'))) {
      console.warn('Suppressed duplicate custom element error:', ...args);
      return;
    }
    originalConsoleError.apply(console, args);
  };
})(); 